<!-- 账号绑定弹窗 -->
<template>
  <van-popup
    v-model:show="show"
    class="result-popup"
    :close-on-click-overlay="false"
  >
    <div class="container">
      <img class="flower" :src="imgUrlMap.flower" alt="" />
      <div class="content">
        <div class="title">您将获得:</div>
        <div class="text1">{{ awardData.name }}</div>
        <div class="text2">请注意查收短信！</div>

        <div class="btn-row">
          <van-button plain @click="toReceive" round>我知道了</van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import { reactive, ref, computed, onBeforeMount, onMounted, defineExpose, defineEmits, defineProps, nextTick } from 'vue'
import { useStore } from 'vuex'
import { Toast } from 'vant';
import anime from 'animejs/lib/anime.es.js';


const emit = defineEmits([]);   //定义一个变量来接收父组件传来的方法

const store = useStore()

const props = defineProps({
  // 封面图片地址
  imgUrlMap: {
    type: Object,
    default: () => { }
  },
  userInfo: {
    type: Object,
    default: () => { }
  },
})

const show = ref(false)
const awardMap = ref({
  0: {
    name: '168元微信立减金+花点时间鲜花券',
    awardUrl: 'https://w.url.cn/s/AcxTZVM#wechat_pay&wechat_redirect',  // 电商女
    awardUrlSk: 'https://w.url.cn/s/ABjw8H6#wechat_pay&wechat_redirect',  // 数科女
  }, // 女
  1: {
    name: '3.7元微信立减金+花点时间鲜花券',
    awardUrl: 'https://w.url.cn/s/AfxRDFL#wechat_pay&wechat_redirect', // 电商男
    awardUrlSk: 'https://w.url.cn/s/AcHmeTj#wechat_pay&wechat_redirect', // 数科男
  }, // 男
}) // 开发测试环境参数
const awardData = ref({})

onBeforeMount(() => {
  // 正式环境地址替换
  if (process.env.VUE_APP_ENV === 'production') {
    console.log('正式环境', process.env.VUE_APP_ENV);
    awardMap.value = {
      0: {
        name: '168元微信立减金+花点时间鲜花券',
        awardUrl: 'https://w.url.cn/s/AHfTW0g#wechat_pay&wechat_redirect',  // 电商女
        awardUrlSk: 'https://w.url.cn/s/AImpahm#wechat_pay&wechat_redirect',  // 数科女
      }, // 女
      1: {
        name: '3.7元微信立减金+花点时间鲜花券',
        awardUrl: 'https://w.url.cn/s/AFQYGv1#wechat_pay&wechat_redirect', // 电商男
        awardUrlSk: 'https://w.url.cn/s/A6KfqPq#wechat_pay&wechat_redirect', // 数科男
      }, // 男
    }

    // 电商男生3.7券
    // https://w.url.cn/s/AFQYGv1#wechat_pay&wechat_redirect
    // 电商女生168券
    // https://w.url.cn/s/AHfTW0g#wechat_pay&wechat_redirect
    // 数科男生3.7券
    // https://w.url.cn/s/A6KfqPq#wechat_pay&wechat_redirect
    // 数科女生168券
    // https://w.url.cn/s/AImpahm#wechat_pay&wechat_redirect

  }
})
const handleOpen = () => {
  show.value = true
  awardData.value = awardMap.value[props.userInfo.gender]
  nextTick(() => {
    flowerAnimation()
  })
}
const handleClose = () => {
  show.value = false
  flowerStop()
}
const toReceive = () => {
  let url = awardData.value.awardUrl
  if (props.userInfo.companyMain === 1) {
    url = awardData.value.awardUrlSk // 数科
  }
  handleClose()

  if (url) {
    console.log(url, 'url==');
    window.location.href = url
  } else {
    Toast.fail('没有领取地址')
  }

}
// 花的动画
const flowerAnimation = () => {
  anime({
    targets: ['.flower'],
    // 左右摇摆角度
    keyframes: [
      { rotate: -10 },
      { rotate: 10 },
    ],
    easing: 'easeInOutSine',
    duration: 600,
    // delay: 600,
    loop: true,
    direction: 'alternate'
  })
}
// 花的动画停止
const flowerStop = () => {
  anime.remove('.flower');
}


defineExpose({
  handleOpen,
  handleClose,
})

</script>

<style lang="less" >
.result-popup {
  background: none;
  .container {
    padding-top: 80px;
    position: relative;
    margin-bottom: 60px;
    .flower {
      position: absolute;
      top: 0;
      left: 80px;
      width: 150px;
      transform-origin: 50% 100%;
    }
  }
  .content {
    padding-top: 60px;
    width: 310px;
    background: #ffffff;
    border-radius: 20px;
    text-align: center;
    line-height: 1.8;
    font-size: 16px;

    .title {
      font-size: 24px;
      color: #000000;
      margin-bottom: 25px;
    }
    .text1 {
      color: #000000;
    }
    .text2 {
      color: #999999;
    }

    .btn-row {
      display: flex;
      justify-content: space-evenly;
      color: #fff;

      button {
        margin: 36px auto;
        width: 220px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        background: #000000;
        border-radius: 23px;
        font-weight: bold;
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}
</style>
